<template>
  <div v-if="applied_coupon.discount_percentage != 100 || !having_coupon">
    <v-select
      v-model="gateway"
      :items="gateways"
      item-text="title"
      item-value="value"
      :label="$t('enrollment.steps.payment.select_gateways')"
      color="primary"
      :disabled="event_type == DEFINES.SCREENER_TYPE_VALUE.SUBSCRIPTION"
    ></v-select>
    <div>
      <StripePaymentForm
        v-if="gateway == 'stripe'"
        ref="stripePaymentForm"
        :mountStripeElement="mountStripeElement"
        :pricing_id="pricing_id"
        :screener_id="screener_id"
        :company="company"
        :coupon_code="coupon_code"
        :event_type="event_type"
        :eventPrefix="eventPrefix"
        :applied_coupon="applied_coupon"
        @success="success"
        @failed="failed"
        @reset="reset"
      ></StripePaymentForm>
    </div>
    <div>
      <PayPalCheckout
        v-show="price && gateway == 'paypal'"
        :pricing_id="pricing_id"
        :screener_id="screener_id"
        :company="company"
        :coupon_code="coupon_code"
        :event_type="event_type"
        :price="price"
        @purchased="success"
        @resetDialog="reset"
      />
    </div>
    <div>
      <MeshulamPayment
        v-if="price && (gateway == 'meshulam' || gateway == 'bit')"
        :pricing_id="pricing_id"
        :screener_id="screener_id"
        :company="company"
        :coupon_code="coupon_code"
        :event_type="event_type"
        :price="price"
        :gateway="gateway"
        @success="success"
        @failed="failed"
        @reset="reset"
      />
    </div>
  </div>
</template>

<script>
import StripePaymentForm from '@/components/paymentGateway/StripePaymentForm';
import PayPalCheckout from '@/components/paymentGateway/PayPalCheckout';
import MeshulamPayment from '@/components/paymentGateway/MeshulamPayment';

export default {
  name: 'PaymentGateway',
  props: {
    event_type: {
      type: Number,
      default: null,
    },
    eventPrefix: {
      type: String,
      default: null,
    },
    company: {
      type: Object,
      defualt: null,
    },
    screener_id: {
      type: Number,
      default: null,
    },
    pricing_id: {
      type: Number|String,
      default: null,
    },
    applied_coupon: {
      type: Object,
      default: null,
    },
    coupon_code: {
      type: String,
      default: null,
    },
    price: {
      type: Number,
      default: null,
    },
    having_coupon: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mountStripeElement: false,
      gateways: null,
      gateway: 'stripe',
    };
  },
  components: {
    StripePaymentForm,
    PayPalCheckout,
    MeshulamPayment,
  },
  mounted() {
    /* Setting stripe element flag for https://github.com/fromAtoB/vue-stripe-elements/issues/15 */
    this.mountStripeElement = true;
    this.getPaymentGatewayList();
  },
  methods: {
    async getPaymentGatewayList() {
      try {
        var response = await this.$store.dispatch(
          'company/listPaymentGateways',
          {
            company_id: this.company.id,
          }
        );

        let _this = this;
        this.gateways = [];
        let defaultPgOption = null;
        Object.keys(response.gateways).forEach(function(key) {
          if (
            (response.gateways[key]['value'] == 'meshulam' &&
              response.gateways[key]['is_enabled'] === true)
              ||
            (defaultPgOption == null && response.gateways[key]['is_enabled'] === true)
            ||
            (defaultPgOption != 'meshulam' &&
              response.gateways[key]['value'] == 'stripe' &&
              response.gateways[key]['is_enabled'] === true)
          ) {
            defaultPgOption = response.gateways[key]['value'];
          }

          if (
            (!_this.company.payment_setting.enabled_payment_gateways ||
              _this.company.payment_setting.enabled_payment_gateways.length ==
                0) &&
            response.gateways[key]['is_enabled']
          ) {
            _this.gateways.push(response.gateways[key]);
          } else if (
            _this.company.payment_setting.enabled_payment_gateways &&
            _this.company.payment_setting.enabled_payment_gateways.indexOf(
              response.gateways[key]['value']
            ) !== -1
          ) {
            _this.gateways.push(response.gateways[key]);
          } else {
            _this.gateway = null;
          }
        });
        this.gateway = defaultPgOption;
      } catch (error) {
        this.$store.dispatch('app/showMessage', {
          message: error.message,
          color: 'error',
        });
      }
    },

    success(response = {}) {
      this.$emit('success', response);
    },

    failed(error = {}) {
      this.$emit('failed', error);
    },

    reset() {
      this.$emit('reset');
    },
  },
};
</script>
<style></style>
